import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonTable = ({ rows, col, width = 80 }) => {
  return (
    <>
      {[...Array(rows)].map((_, index) => (
        <tr key={`row-${index}`}>
          {[...Array(col)].map((_, index) => (
            <td key={`col-${index}`}>
              <Skeleton height={14} width={width} count={col} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default SkeletonTable;
